/**
 * Inline stylesheet object for Paged.js polisher.add().
 *
 * Paged.js does NOT rely on `@page { margin }` alone: it lays out `.pagedjs_pagebox` using
 * CSS variables `--pagedjs-margin-*` (see node_modules/pagedjs/src/polisher/base.js).
 * Those vars must match our margins or content sits flush to the sheet edge in preview.
 */

import type { PrintPageMarginsMm } from '@/lib/print/paperPresets';

export function pagedPrintStylesheet(
  pageSizeCss: string,
  margins: PrintPageMarginsMm,
): Record<string, string> {
  const { top, right, bottom, left } = margins;

  return {
    'priorities-paged-print.css': `
      @page {
        size: ${pageSizeCss} portrait;
        margin-top: ${top}mm;
        margin-right: ${right}mm;
        margin-bottom: ${bottom}mm;
        margin-left: ${left}mm;
      }

      /*
       * Bridge @page margins into Paged.js layout. !important wins over later polisher merges
       * that would otherwise collapse bands (title hugging the sheet edge).
       */
      .priorities-pagedjs-root,
      .priorities-pagedjs-root .pagedjs_page,
      .priorities-pagedjs-root .pagedjs_pagebox {
        --pagedjs-margin-top: ${top}mm !important;
        --pagedjs-margin-right: ${right}mm !important;
        --pagedjs-margin-bottom: ${bottom}mm !important;
        --pagedjs-margin-left: ${left}mm !important;
      }

      @media print {
        html, body {
          margin: 0 !important;
          padding: 0 !important;
        }
      }
    `,
  };
}
